// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18M2h","footer":"styles_footer__2OMcQ","passCodeTooltip":"styles_passCodeTooltip__22zhq"};